/**
 * Get the current date in a timezone as YYYY-MM-DD string.
 * Defaults to America/New_York for backward compatibility.
 * @param {string} [timeZone='America/New_York']
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function getTodayInTimezone(timeZone = 'America/New_York') {
  const now = new Date()
  const local = new Date(now.toLocaleString('en-US', { timeZone }))

  const year = local.getFullYear()
  const month = String(local.getMonth() + 1).padStart(2, '0')
  const day = String(local.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/**
 * @deprecated Prefer getTodayInTimezone
 * @returns {string} Date string in format YYYY-MM-DD (US/Eastern timezone)
 */
export function getTodayInEastern() {
  return getTodayInTimezone('America/New_York')
}

/**
 * Format an ISO datetime in a campaign timezone as MM-DD-YYYY, hh:mm AM/PM.
 * @param {string} dateString
 * @param {string} [timeZone='America/New_York']
 * @returns {string}
 */
export function formatInTimezone(dateString, timeZone = 'America/New_York') {
  if (!dateString) return ''
  const tz = timeZone || 'America/New_York'
  const date = new Date(dateString)
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date)

  const get = (type) => parts.find((p) => p.type === type)?.value || ''
  return `${get('month')}-${get('day')}-${get('year')}, ${get('hour')}:${get('minute')} ${get(
    'dayPeriod',
  )}`
}
